<template>
	<div>
		<buttonlist @help="help" @exps="exps"   ref="SetBtn"></buttonlist>
		<el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-date-picker
					v-model="Month"
					value-format="yyyy-MM"
					type="month">
					</el-date-picker>
					
					<el-button type="primary" size="mini" style="margin-left: 5px;" @click="getView()" >{{$t('getapi[1980]')}}</el-button>

					<!-- <el-button type="primary" size="mini" style="margin-left: 5px;" @click="exps()" >导出库存收发存</el-button> -->
					
				</div>
			</div>
		</el-card> 
			<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px">
				<el-tabs :tab-position="'top'" v-model="SelectIndex" type="" style="margin-top: 0px" @tab-click="selectInfo">
					
					<el-tab-pane :label="$t('getapi[7295]')" name="1">
						
					<vxe-table
						:data="dataSet"
						v-loading="loading"
						border
						stripe
						resizable
						size="mini"
						:height="tableHeight"
						ref="singleTable1"
						>
						<vxe-table-column show-overflow field="item_name" :title="$t('getapi[7296]')"  width='150'/>
						<vxe-table-column show-overflow field="amount" :title="$t('getapi[2102]')" align="right" width='150'/>
						<vxe-table-column show-overflow field="remark" :title="$t('getapi[2078]')"  width='250'/>
					</vxe-table>
						<el-button type="primary" size="mini" style="padding-top:5px;" @click="diffcostview()" >{{$t('getapi[7297]')}}</el-button>
					</el-tab-pane>
					
				
				


				
				<el-tab-pane :label="$t('getapi[7298]')" name="5">
				<vxe-table
				:data="dataSet"
				v-loading="loading"
				border
				stripe
				resizable
				size="mini"
				:height="tableHeight"
				ref="singleTable5"
				>
				<vxe-table-column show-overflow field="年份" :title="$t('getapi[1974]')" align="right" width='80'/>
				<vxe-table-column show-overflow field="月份" :title="$t('getapi[1975]')" align="right" width='80'/>
				<vxe-table-column show-overflow field="物料编码" :title="$t('getapi[112]')"  width='150'/>
				<vxe-table-column show-overflow field="物料版本" :title="$t('getapi[149]')"  width='150'/>
				<vxe-table-column show-overflow field="存货类别1" :title="$t('getapi[169]')"  width='150'/>
				<vxe-table-column show-overflow field="存货类别2" :title="$t('getapi[170]')"  width='150'/>
				<vxe-table-column show-overflow field="存货类别3" :title="$t('getapi[171]')"  width='150'/>
				<vxe-table-column field="期初数" :title="$t('getapi[7299]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期初数 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期初单价直接材料" :title="$t('getapi[7300]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期初单价直接材料 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期初单价直接人工" :title="$t('getapi[7301]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期初单价直接人工 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期初单价制造费用" :title="$t('getapi[7302]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期初单价制造费用 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期初金额直接材料" :title="$t('getapi[7303]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期初金额直接材料 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期初金额直接人工" :title="$t('getapi[7304]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期初金额直接人工 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期初金额制造费用" :title="$t('getapi[7305]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期初金额制造费用 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库数" :title="$t('getapi[1850]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.入库数 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库单价" :title="$t('getapi[4747]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.入库单价 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库金额采购" :title="$t('getapi[7306]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.入库金额采购 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库金额票到补差采购" :title="$t('getapi[7307]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.入库金额票到补差采购 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库金额生产直接材料" :title="$t('getapi[7308]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.入库金额生产直接材料 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库金额生产直接人工" :title="$t('getapi[7309]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.入库金额生产直接人工 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库金额生产制造费用" :title="$t('getapi[7310]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.入库金额生产制造费用 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库金额调整直接材料" :title="$t('getapi[7311]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.入库金额调整直接材料 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库金额调整直接人工" :title="$t('getapi[7312]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.入库金额调整直接人工 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库金额调整制造费用" :title="$t('getapi[7313]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.入库金额调整制造费用 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库金额隔月返修直接材料" :title="$t('getapi[7314]')" align="right" width='160'>
					<template slot-scope="scope">
						{{ scope.row.入库金额隔月返修直接材料 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库金额隔月返修直接人工" :title="$t('getapi[7315]')" align="right" width='160'>
					<template slot-scope="scope">
						{{ scope.row.入库金额隔月返修直接人工 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="入库金额隔月返修制造费用" :title="$t('getapi[7316]')" align="right" width='160'>
					<template slot-scope="scope">
						{{ scope.row.入库金额隔月返修制造费用 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="发出数" :title="$t('getapi[7317]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.发出数 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="发出数调整" :title="$t('getapi[7318]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.发出数调整 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="发出单价直接材料" :title="$t('getapi[7319]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.发出单价直接材料 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="发出单价直接人工" :title="$t('getapi[7320]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.发出单价直接人工 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="发出单价制造费用" :title="$t('getapi[7321]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.发出单价制造费用 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="发出金额直接材料" :title="$t('getapi[7322]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.发出金额直接材料 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="发出金额直接人工" :title="$t('getapi[7323]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.发出金额直接人工 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="发出金额制造费用" :title="$t('getapi[7324]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.发出金额制造费用 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="发出金额调整直接材料" :title="$t('getapi[7325]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.发出金额调整直接材料 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="发出金额调整直接人工" :title="$t('getapi[7326]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.发出金额调整直接人工 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="发出金额调整制造费用" :title="$t('getapi[7327]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.发出金额调整制造费用 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期末数" :title="$t('getapi[7328]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期末数 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期末单价直接材料" :title="$t('getapi[7329]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期末单价直接材料 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期末单价直接人工" :title="$t('getapi[7330]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期末单价直接人工 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期末单价制造费用" :title="$t('getapi[7331]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期末单价制造费用 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期末金额直接材料" :title="$t('getapi[7332]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期末金额直接材料 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期末金额直接人工" :title="$t('getapi[7333]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期末金额直接人工 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column field="期末金额制造费用" :title="$t('getapi[7334]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.期末金额制造费用 | thousandth}}
					</template>
				</vxe-table-column>

				</vxe-table>
				</el-tab-pane>
				<el-tab-pane :label="$t('getapi[7335]')" name="2">
				<vxe-table
				:data="dataSet"
				v-loading="loading"
				border
				stripe
				resizable
				size="mini"
				:height="tableHeight/2"
				ref="singleTable2"
				>
				<vxe-table-column show-overflow field="data_source" :title="$t('getapi[7336]')"  width='150'/>
				<vxe-table-column show-overflow field="category_first_name" :title="$t('getapi[169]')" align="right" width='150'/>
				<vxe-table-column show-overflow field="summary" :title="$t('getapi[7337]')"  width='150'/>
				<vxe-table-column show-overflow field="id_name" :title="$t('getapi[2235]')"  width='150'/>
				<vxe-table-column field="amount" :title="$t('getapi[7338]')"  align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.amount | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column show-overflow field="fin_subject" :title="$t('getapi[7339]')"  width='150'/>

				</vxe-table>

				<vxe-table
				:data="dataSet2"
				v-loading="loading"
				border
				stripe
				resizable
				size="mini"
				:height="tableHeight/2"
				>
				<vxe-table-column show-overflow field="data_source1" :title="$t('getapi[7336]')"  width='150'/>
				<vxe-table-column field="amount1" :title="$t('getapi[2248]')" align="right"  width='150'>
					<template slot-scope="scope">
						{{ scope.row.amount1 | thousandth}}
					</template>
				</vxe-table-column>
				<vxe-table-column show-overflow field="fin_subject1" :title="$t('getapi[7340]')"  width='150'/>
				</vxe-table>

				</el-tab-pane>
				<el-tab-pane :label="$t('getapi[7341]')" name="4">
				<vxe-table
				:data="dataSet"
				v-loading="loading"
				border
				stripe
				resizable
				size="mini"
				:height="tableHeight"
				ref="singleTable4"
				>
				<vxe-table-column show-overflow field="data_source2" :title="$t('getapi[7342]')"  width='150'/>
				<vxe-table-column field="amount2" :title="$t('getapi[7343]')" align="right" width='150'>
					<template slot-scope="scope">
						{{ scope.row.amount2 | thousandth}}
					</template>
				</vxe-table-column>

				</vxe-table>
				</el-tab-pane>
				<el-tab-pane :label="$t('getapi[7344]')" name="3">
				<vxe-table
				:data="dataSet"
				v-loading="loading"
				border
				stripe
				resizable
				size="mini"
				:height="tableHeight"
				ref="singleTable3"
				>
				<vxe-table-column show-overflow field="cost_item" :title="$t('getapi[7345]')"  width='150'/>
				<vxe-table-column show-overflow field="data" :title="$t('getapi[7346]')" align="right" width='150'/>
				<vxe-table-column show-overflow field="remark" :title="$t('getapi[7343]')"  width='250'/>
				<vxe-table-column show-overflow field="method" :title="$t('getapi[7347]')"  width='250'/>
				

				</vxe-table>
				</el-tab-pane>
				</el-tabs>

				


			
			</li>
		</ul>
			<!-- <el-row>
				<el-col :span="18">
					<el-pagination
						style="margin-top: 1em"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="100"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames }}</div>
				</el-col>
			</el-row> -->
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="SumRunningHourInfo" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<!-- <ctable :isVisible="false" title="CSV" queryData="SalLogicticscsvViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable> -->
	
		<!-- 详情页面 -->
		<!-- <purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage> -->
		<!-- 选择时间 -->
		<el-dialog v-dialogDrag :title="$t('getapi[6433]')" :visible.sync="dialogVisible" width="30%">
			<div class="bbl">
			<span>{{$t('getapi[6434]')}}</span>
			<el-date-picker v-model="copyparam.startMonth" popper-class="select-option" type="month" value-format="yyyy-MM" size="mini"></el-date-picker>
			</div>
			<div class="bbl">
			<span>{{$t('getapi[6435]')}}</span>
			<el-date-picker v-model="copyparam.copyMonth" popper-class="select-option" type="month" value-format="yyyy-MM" size="mini"></el-date-picker>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="dialogVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="copyconfirm">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>
		<!-- 查看入库成本差异明细 -->
		<el-dialog v-dialogDrag :title="$t('getapi[7348]')" :visible.sync="visDiffCostView" width="80%" :close-on-click-modal="false" >
            <el-table
                    :data="DiffCostView"
                    :highlight-current-row="true"
                    :height="tableHeight - 200"
					v-loading="loading"
					stripe
					resizable
                    border
                    size="mini"
                    style="width: 100%;"
					header-row-class-name="headerclass"					
				>
                <!-- <el-table-column type="selection" v-if="false"></el-table-column> -->
                <el-table-column show-overflow prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                <el-table-column show-overflow prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                <el-table-column show-overflow prop="Invoice_Amount" :label="$t('getapi[7349]')" align="right"></el-table-column>
                <el-table-column show-overflow prop="Just_Amount" :label="$t('getapi[7350]')" align="right"></el-table-column>
                <el-table-column show-overflow prop="Estimate_Amount" :label="$t('getapi[7351]')" align="right"></el-table-column>
                <el-table-column show-overflow prop="Prior_Estimate_Amount" :label="$t('getapi[7352]')" align="right"></el-table-column>
                <el-table-column show-overflow prop="Inventory_Amount" :label="$t('getapi[7353]')" align="right"></el-table-column>
                <el-table-column show-overflow prop="diff_amount" :label="$t('getapi[7354]')" align="right"></el-table-column>
                <el-table-column show-overflow prop="reason" :label="$t('getapi[7355]')" width="200"></el-table-column>
			</el-table>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" size="mini" @click="visDiffCostView = false">{{$t('getapi[441]')}}</el-button>
				<el-button type="primary" size="mini" @click="diffcostlineviewtoexecl()">{{ $t('getapi[922]') }}</el-button>
			</span>

		
        </el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_diffcost',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight-240,
                maxHeight: this.$windowSize.tableHeight-240,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight-210
        }
    },
	data() {
		return {
			totalcost:0,
			Month:'',
			viewurl:'/CostCalc/ActualCsotView/GetDiffCostView',
			expurl:'/CostCalc/ActualCsotView/GetDiffCostViewToExecl',
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			dataSet2: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 100, // 当前页数据量
			SelectIndex: '1', //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				//拷贝
				send: false,
				print:false,
				//删除
				delete: false,
			},
			visDiffCostView: false,
			DiffCostView:[],//入库成本差异明细
            scrollTop1:0,
            scrollTop2:0,
            scrollTop3:0,
            scrollTop4:0,
            scrollTop5:0,
		};
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		

	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop1 = res.target.scrollTop
            },false)
            that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop2 = res.target.scrollTop
            },false)
            that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop3 = res.target.scrollTop
            },false)
            that.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop4 = res.target.scrollTop
            },false)
            that.$refs.singleTable5.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop5 = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                this.$refs.singleTable4.bodyWrapper.scrollTop =this.scrollTop4;
                this.$refs.singleTable5.bodyWrapper.scrollTop =this.scrollTop5;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('SalLogicticscsvViewInfo',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
		selectInfo(tab, event) {
		let that = this;
		that.SelectIndex = tab.name;
		that.getView();
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6651]"),this.$t("getapi[6633]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			let limits=1;
			//that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);

			that.$refs.SetBtn.SetButtonEnable('',true);
			return;

			// //只读权
			// if (that.$limits.ReadOnlyRightsView('plv2', 375, 1, that.total)) {
			// 	if (that.total > 0) {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 	} else {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 	}
			// }
			// //操作权限-查询级别
			// limits = that.$limits.OperationAuthorityView('plv2', 375, 1, that.total);
			// // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			// switch (limits) {
			// 	case -1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	default:
			// 		break;
			// }
			// if(limits==-1||limits==1)that.closeAllRightButton();
            // else that.btnauthority();
		},
		btnauthority() {
			let that = this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
			
		},
		closeAllRightButton(){
			let that =this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		},
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange(val) {
		let that = this;
		that.selectIDList=val;
		if(that.selectIDList.length>0){
			that.btn.send = true;
			that.btn.delete = true;
			that.btn.print = true;
		}else{
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		}
		},
		
		handleSizeChange(val) {
			this.pageSize = val;
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'SumRunningHourInfo');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		// getView() {
		// 	let that = this;
		// 	that.loading = true;
		// 	let datac = [];
		// 	for (let i = 0; i < that.queryData.length; i++) {
		// 		datac.push({
		// 			query_Condition: that.queryData[i].query_Condition,
		// 			query_field_type: that.queryData[i].Query_Field_Type,
		// 			query_field_name: that.queryData[i].Query_Field_Name,
		// 			query_sort: that.queryData[i].query_sort,
		// 			row_sign: that.queryData[i].row_sign
		// 		});
		// 	}
		// 	let token = JSON.parse(that.userData).token;
		// 	let data = {
		// 		PageIndex: that.pageIndex,
		// 		PageSize: that.pageSize,
		// 		Param: datac
		// 	};
		// 	that.$http.urlpost(that.viewurl, data, function(res) {
		// 		if (res.Success == 1) {
		// 			that.dataSet = res.DataContent;
		// 			that.total = res.Totals;
		// 			that.loading = false;
		// 			that.DbTbNames = res.DbTbNames;
		// 		} else {
		// 			that.$message.error(res.Msg);
		// 		}
		// 		that.authority();
		// 	});
		// },
		diffcostview(){
			let that = this;
			if(that.$limits.fnIsEmpty(that.Month)){
				that.$message.warning(that.$t('getapi[6086]'));//"请选择日期"
				return;
			}
			that.loading = true;
			that.visDiffCostView=true;
			let parm = {
				TYear: that.Month.split('-')[0],
				Month:  that.Month.split('-')[1],
			}
			that.$http.urlpost('/CostCalc/ActualCsotView/GetDiffCostLineView', parm, function (res) {
				if (res.Success == 1) {
					that.DiffCostView = res.DataContent.Table;
				}
			})
			that.loading = false;
		},
		diffcostlineviewtoexecl(){
			let that = this;
			if(that.$limits.fnIsEmpty(that.Month)){
				that.$message.warning(that.$t('getapi[6086]'));//"请选择日期"
				return;
			}
			that.loading = true;
			let parm = {
				TYear: that.Month.split('-')[0],
				Month:  that.Month.split('-')[1],
			}
			that.$http.urlpost('/CostCalc/ActualCsotView/GetDiffCostLineViewToExecl', parm, function (res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
				}

			})
			that.loading = false;
		},
		getView(){
		let that = this;
			if(that.$limits.fnIsEmpty(that.Month))
			{
				that.$message.warning(that.$t('getapi[6086]'));//"请选择日期"
				return;
			}
				let datac ={
					TYear: that.Month.split('-')[0],
					Month:  that.Month.split('-')[1],
					SelectIndex:that.SelectIndex
				};
				that.loading = true;
				//console.log(datac)
			that.$http.urlpost(that.viewurl, datac, function(res) {
			if (res.Success == 1) {
				
				if(that.SelectIndex=="1"||that.SelectIndex=="3"||that.SelectIndex=="4")that.dataSet = res.DataContent.Table;
				if(that.SelectIndex=="5")that.dataSet = res.DataContent.Table1;
				if(that.SelectIndex=="2"){
					that.dataSet = res.DataContent.Table;
					that.dataSet2 = res.DataContent.Table1;
				}
				if(that.SelectIndex=="5"){
					that.$refs.SetBtn.SetButtonEnable('export',true);
				}else {
					that.$refs.SetBtn.SetButtonEnable('',true);
				}

			}
			that.loading = false;
			});
		},
		// 导出
		exps() {
			let that = this;
			that.loading = true;
			if(that.$limits.fnIsEmpty(that.Month))
			{
				that.$message.warning(that.$t('getapi[6086]'));//"请选择日期"
				return;
			}
			let datac ={
			TYear: that.Month.split('-')[0],
			Month:  that.Month.split('-')[1],
			SelectIndex:that.SelectIndex,
                LangType: that.$processdata.getLang(),
                fromname: that.$t('getapi[6651]')
			};
			that.$http.urlpost(that.expurl, datac, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		//按月拷贝成本
		copy(){
			let that = this;
			that.dialogVisible = true;
			
		},
		copyconfirm(){
			//  
			let that = this;
			that.btn.copy = false
			let parm = {
			"newmonth": that.copyparam.copyMonth.split("-")[1],
			"newyear": that.copyparam.copyMonth.split("-")[0],
			"oldmonth": that.copyparam.startMonth.split("-")[1],
			"oldyear": that.copyparam.startMonth.split("-")[0],
			}

			that.$http.urlpost('/Inv/PartCost/InvPartStdCostCopyCost', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
				that.btn.copy = true;
				that.dialogVisible = false;
			});


		},
		send(){
			let that = this;
			that.loading = true;
			that.$http.urlpost('/CostCalc/PurView/GetLatestPurPriceView', {}, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
				}
				that.loading = false;
			});
		},
		print(){
			let that = this;
			let parm = {
			po_no: '',
			TemplateName: '08Invoice_CSV.xlsx'
			};

			for(let i=0;i<that.selectIDList.length;i++){
			parm.po_no= parm.po_no + "'"+that.selectIDList[i].exclusively_id+"',";
			}
			parm.po_no =  parm.po_no.substring(0, parm.po_no.length - 1);

			that.btn.print = false;
			that.loading = true;
			that.$http.urlpost('/Print/CSVPrint', parm, function (res) {
			that.btn.print = true;
			if (res.Success == 1) {
			let hrefurl = res.Key;
			window.open(hrefurl);
			} 
			that.loading = false;
			});
		},
		deleteline(){
			let that = this;
			let parm = {
				Delivery_Note_N: that.selectIDList[0].Delivery_Note_N,
			};
			that.$http.urlpost('/Sal/Tru/DeleteCsv', parm, function(res) {
				if (res.Success == 1) {
					that.reflash();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
				}
			});

		},

		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
